import React from 'react';
import styled from 'styled-components';
import Icon from '@mdi/react';
import { mdiAlertCircleOutline, mdiClose } from '@mdi/js';

const Container = styled.div`
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 800;
  background: #fff3e0;
  border: 1px solid #ffcc02;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  max-width: 480px;
  width: 90%;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid #ffe0b2;
  font-weight: 600;
  font-size: 13px;
  color: #e65100;
`;

const CloseBtn = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  color: #bf360c;
  padding: 2px;
  &:hover { opacity: 0.7; }
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 10px 14px;
`;

const Item = styled.li`
  font-size: 12px;
  color: #4e342e;
  padding: 3px 0;
  &::before {
    content: '\u2022';
    color: #e65100;
    margin-right: 8px;
  }
`;

interface ValidationErrorsProps {
  errors: string[];
  onClose: () => void;
}

export const ValidationErrors: React.FC<ValidationErrorsProps> = ({ errors, onClose }) => {
  if (errors.length === 0) return null;

  return (
    <Container>
      <Header>
        <Icon path={mdiAlertCircleOutline} size={0.7} color="#e65100" />
        Circuit has {errors.length} issue{errors.length > 1 ? 's' : ''}
        <CloseBtn onClick={onClose}>
          <Icon path={mdiClose} size={0.6} />
        </CloseBtn>
      </Header>
      <List>
        {errors.map((err, i) => (
          <Item key={i}>{err}</Item>
        ))}
      </List>
    </Container>
  );
};
